import APIEndpoints from '@utils/APIEndpoints';
import axios from 'axios';
import {
  ChangePasswordData,
  CustomerInformation,
  LoginParam,
  SendOtpForgotPasswordData,
  SendVerifyCodeParam,
  Serial,
  SignUpParam,
  UpdateCustomerData,
  VerifyCodeForgotPasswordData,
  VerifyCodeParam,
  WarrantyUser,
} from '../type';
import { useApiRequest } from '../useApiRequest';

// #TODO : use fetch instead of axios
export async function getCsrfCookie() {
  await axios.get(APIEndpoints.WARRANTY_URL + '/sanctum/csrf-cookie', { withCredentials: true });
}

export function useLogin() {
  return useApiRequest<any, LoginParam>(`login`);
}

export function useSignUp() {
  return useApiRequest<any, SignUpParam>(`register`);
}

export function useSendVerifyCode() {
  return useApiRequest<boolean, SendVerifyCodeParam>(`sms/send-verify-code`);
}

export function useVerifyCode() {
  return useApiRequest<boolean, VerifyCodeParam>(`sms/verify-code`);
}

export function useGetSerialByCode(code: string) {
  return useApiRequest<Serial>(`scan/${code}`, `GET`);
}

export function useUpdateCustomer() {
  return useApiRequest<WarrantyUser, UpdateCustomerData>(`user/profile-information`, `PUT`);
}

export function useChangePassword() {
  return useApiRequest<boolean, ChangePasswordData>(`change-pw`, `POST`);
}

export function useSendOtpForgotPassword() {
  return useApiRequest<boolean, SendOtpForgotPasswordData>(`sms/send-forgot-pw`);
}

export function useVerifyCodeForgotPassword() {
  return useApiRequest<boolean, VerifyCodeForgotPasswordData>(`sms/verify-code-forgot-pw`);
}
export function useValidateInformation() {
  return useApiRequest<boolean, CustomerInformation>(`validate-information`, `POST`);
}
